interface Formula {
  structure: object[]
  data: JSON
}

export const checkFormulasBody = (formula: Formula | null) => {
  if (
    formula &&
    formula?.data &&
    formula?.structure &&
    formula.structure.length > 0 &&
    Object.keys(formula.data).length > 0
  ) {
    return formula
  }
  return null
}
